import RotateItemCommand from '../command/rotateItemCommand';
import FloatField from './floatField';

/**
 * @class RotationField
 */
export default class RotationField extends FloatField {
    type = 'rotation';
    supports = 'supportsRotation';

    /**
     * Update item with field value.
     * Considers the initial rotation of the item.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.getNormalizedRotation());
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        let rotation = this.getValue();

        if (item.supportsInitialRotation) {
            rotation += item.get('initialRotation') || 0;
            rotation %= 360;
        }

        const command = new RotateItemCommand(item, rotation);

        history.addAndExecuteCommand(command);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        let rotation = this.getValue() + difference;

        if (item.supportsInitialRotation) {
            rotation += item.get('initialRotation') || 0;
            rotation %= 360;
        }

        const command = new RotateItemCommand(item, rotation);

        history.addAndExecuteCommand(command);
    }

    /**
     * Check if field is supported by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const isSupported = super.isSupported(item, selectionLength);

        return isSupported && item && (item.supportsFreeRotation || !item.supportsSnappedRotation());
    }
}
